import ui from "./ui/reducer";
import customer from "./customer/reducer";

const rootReducer = {
	ui,
	customer,
};

export default rootReducer;
